import { Component, Inject, OnInit } from '@angular/core';
import { createDNIDuplicateValidator, DNIAlreadyExistsValidator } from '../Common/validators-dni';
import {UntypedFormGroup, UntypedFormControl, UntypedFormArray, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '../Common/modal-window/modal-window.service';
import { SHARED_IMPORTS,  } from 'src/app/Common/shared.config';
import { ModalWindowBaseComponent } from '../Common/modal-window/modal-window-base.component';
import { InscripcionesService, IPersonaRecord } from '../Common/inscripciones.service';


@Component({
    selector: 'app-web-inscripciones-invitados',
    templateUrl: './web-inscripciones-invitados.component.html',
    styleUrls: [
        '../Common/form.scss',
        './web-inscripciones-invitados.component.scss'
    ],
    standalone: true,
    imports: [...SHARED_IMPORTS]
})
export class WebInscripcionesInvitadosComponent extends ModalWindowBaseComponent implements OnInit {
    public invitados_group = new UntypedFormGroup({
//        dni: new UntypedFormControl('', {
//            validators: [
//                Validators.required,
//                createDNIDuplicateValidator(this)
//            ],
//            asyncValidators: [DNIAlreadyExistsValidator(this.InscripcionesS)],
//            updateOn: 'blur'
//        }),
        dni_validation_group: this.InscripcionesS.form_validation_dni,
        acto_social:  new UntypedFormControl('', []),
        nombre: new UntypedFormControl('', [
            Validators.required,
        ]),
        apellido1: new UntypedFormControl('', [
            Validators.required,
        ]),
        apellido2: new UntypedFormControl('', [
            Validators.required,
        ]),
        empresa: new UntypedFormControl('', []),
        tipo_empresa: new UntypedFormControl('', []),
        cargo: new UntypedFormControl('', []),
        direccion: new UntypedFormControl('', []),
        ciudad: new UntypedFormControl('', []),
        codigo_postal: new UntypedFormControl('', []),
        pais: new UntypedFormControl('', []),

        email: new UntypedFormControl('', [
            Validators.required,
            Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$"),
        ]),
        telefono: new UntypedFormControl('', [
              Validators.required,
        ]),
    });

    public ctrl_dni: UntypedFormControl;
    public edit_mode = false;
  // ===========================================================================
  // ---------------------------------------------------------------------------
  constructor(
      public InscripcionesS: InscripcionesService,
    //   public moda_window_ref: MatDialogRef<WebInscripcionesInvitadosComponent>,
      @Inject(MAT_DIALOG_DATA) public data: any
  ) {
      super();

      // console.log(data);
      // console.log(typeof data);
      const dniValidationFormGroup = <UntypedFormGroup> this.invitados_group.get('dni_validation_group');
      this.ctrl_dni = <UntypedFormControl> dniValidationFormGroup.get('dni');
  }

  // ---------------------------------------------------------------------------
  ngOnInit() {
       for (let control_name in this.data) {
           console.log(control_name);
           if (control_name === 'dni') {
               this.ctrl_dni.setValue(this.data[control_name]);
           } else {
               let ctrl = null;
               if ( ctrl = this.invitados_group.controls[control_name] ) {
                 ctrl.setValue(this.data[control_name]);
               } else {
                  console.log(control_name + ' no existe control');
               }
           }
      
       };
      this.values = this.data;
      this.edit_mode = (this.data.dni?true:false);

  }

  // ---------------------------------------------------------------------------
  get values(): any {
      const ret_values = Object.assign({}, this.invitados_group.value, {
          dni: this.ctrl_dni.value.toUpperCase(),
          foro1: '',
          foro2: '',
          id_padre: null,         // debe actualizase en servidor
          relacion_padre: 1,      // Invitado del padre
          tipo_incripcion: 5,     // Invitado
          fecha_alta: '',         // debe actualizase en servidor
          ha_asistido: 0,
          fecha_asistencia: '',
          fecha_asistencia_coctel: '',
          empresa_invitacion: '',
          tipo_registro: 'web',
          fecha_envio_mail: '',
          codigo_qr: '',           // debe actualizase en servidor
          fecha_pendiente: '',
          con_factura: 0,
          importe_factura: 0,
          codigo_autorizacion: '',
          tipo_empresa: ''
      });

      return ret_values;
  }
  // ---------------------------------------------------------------------------
  set values(valores: any) {
      for (let control_name in valores) {
          // console.log(control_name);
          if ( this.invitados_group.controls[control_name] ) {
            this.invitados_group.controls[control_name].setValue(valores[control_name]);
        } else {
            console.log(control_name + ' no existe control');
        }

      };

  }

}
